
import { useState } from 'react';

const productImages = [
  {
    id: 1,
    src: 'https://public.readdy.ai/ai/img_res/ec21043fb7d9165b8ecc8a636f9638ae.jpg',
    alt: '삼성 990 PRO 2TB 정면'
  },
  {
    id: 2,
    src: 'https://readdy.ai/api/search-image?query=Samsung%20990%20PRO%20NVMe%20M.2%20SSD%20back%20side%20showing%20circuit%20board%20and%20NAND%20chips%20on%20clean%20white%20background%20professional%20product%20photography%20with%20soft%20studio%20lighting&width=800&height=800&seq=990pro-back-002&orientation=squarish',
    alt: '삼성 990 PRO 2TB 후면'
  },
  {
    id: 3,
    src: 'https://readdy.ai/api/search-image?query=Samsung%20990%20PRO%20NVMe%20SSD%20installed%20on%20modern%20motherboard%20M.2%20slot%20close%20up%20professional%20technology%20photography%20with%20soft%20lighting&width=800&height=800&seq=990pro-installed-003&orientation=squarish',
    alt: '메인보드 장착 모습'
  },
  {
    id: 4,
    src: 'https://readdy.ai/api/search-image?query=Samsung%20990%20PRO%202TB%20SSD%20retail%20box%20packaging%20with%20product%20visible%20on%20clean%20white%20background%20professional%20product%20photography%20with%20soft%20studio%20lighting&width=800&height=800&seq=990pro-box-004&orientation=squarish',
    alt: '제품 패키지'
  }
];

export default function ProductGallery() {
  const [selectedImage, setSelectedImage] = useState(0);

  // Guard against out‑of‑range index (e.g., if the array changes dynamically)
  const safeIndex =
    selectedImage >= 0 && selectedImage < productImages.length
      ? selectedImage
      : 0;

  const mainImage = productImages[safeIndex];

  return (
    <div className="flex flex-col gap-4">
      {/* Main Image */}
      <div className="w-full h-[480px] bg-gray-50 rounded-xl overflow-hidden border border-gray-100">
        <img
          src={mainImage.src}
          alt={mainImage.alt}
          title="삼성전자 990 PRO 2TB NVMe SSD"
          className="w-full h-full object-contain object-top p-4"
        />
      </div>

      {/* Thumbnails */}
      <div className="grid grid-cols-4 gap-3">
        {productImages.map((image, index) => (
          <button
            key={image.id}
            onClick={() => setSelectedImage(index)}
            className={`w-full h-24 rounded-lg overflow-hidden border-2 transition-all cursor-pointer ${
              safeIndex === index
                ? 'border-teal-600 shadow-md'
                : 'border-gray-200 hover:border-gray-300'
            }`}
          >
            <img
              src={image.src}
              alt={image.alt}
              className="w-full h-full object-contain p-1"
            />
          </button>
        ))}
      </div>
    </div>
  );
}
